var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'width':_vm.width,'height':_vm.height,'position':'relative','font-size':_vm.font_size})},[_c('div',{staticClass:"item_head"},[_c('span',{staticClass:"item_head_name"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"item_head_unit"},[_vm._v(_vm._s(_vm.unit))])]),_c('div',{staticClass:"echart",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }